import SearchFilterTab from '@components/cockpit/panels/notificationSearch/categoryFilters/SearchFilterTab';
import {
  DurationFilter,
  PeriodFilter,
  WorstStatusFilter,
} from '@components/cockpit/panels/notificationSearch/filterComponents/AdditionalFilters';
import {
  IdentifierFilter,
  PlatformFilter,
} from '@components/cockpit/panels/notificationSearch/filterComponents/SearchFilters';
import { SearchFilterOptionEnum } from '@components/cockpit/panels/notificationSearch/notificationSearch.types';
import { useNotificationSearchContext } from '@components/cockpit/panels/notificationSearch/NotificationSearchContext';
import { useState } from 'react';

import { NotificationFamilyEnum } from '@/types/data/data.types';

export default function TechnicalFilters() {
  const { filters, displayedFilterOptions } = useNotificationSearchContext();

  const [resetKey, setResetKey] = useState(0);

  return (
    <SearchFilterTab
      category={NotificationFamilyEnum.TECHNICAL}
      onReset={() => {
        setResetKey((prev) => prev + 1);
      }}
    >
      {displayedFilterOptions.has(SearchFilterOptionEnum.PLATFORM) && <PlatformFilter />}
      {displayedFilterOptions.has(SearchFilterOptionEnum.ID) && <IdentifierFilter />}
      <PeriodFilter key={`${filters.category}-${resetKey}`} isDetection={false} />
      {displayedFilterOptions.has(SearchFilterOptionEnum.WORST_SENSOR_STATUS) && <WorstStatusFilter />}
      {displayedFilterOptions.has(SearchFilterOptionEnum.TREATMENT_DURATION) && <DurationFilter isDetection={false} />}
    </SearchFilterTab>
  );
}
